/* bb-quizzes.js v2 - bouddha-bouddhisme.com */
(function(){
var FONT_URL='https://fonts.googleapis.com/css2?family=Fraunces:opsz,wght@9..144,400;9..144,600&family=DM+Sans:opsz,wght@9..40,400;9..40,500&display=swap';
var fl=document.createElement('link');fl.rel='preload';fl.as='style';fl.href=FONT_URL;document.head.appendChild(fl);
var fl2=document.createElement('link');fl2.rel='stylesheet';fl2.href=FONT_URL;document.head.appendChild(fl2);

var Q=[
  {id:0,name:'Idee cadeau ZEN',sub:'Trouvez le cadeau parfait',
    steps:[
      {q:"Ce cadeau, c'est pour...",opts:[
        {l:"Pour elle",s:"&#9825;",v:"f"},
        {l:"Pour lui",s:"&#9794;",v:"m"},
        {l:"Un couple",s:"&#10084;",v:"c"},
        {l:"Enfant / ado",s:"&#9733;",v:"k"}]},
      {q:"Quel est votre budget ?",opts:[
        {l:"Moins de 20€",s:"&#9671;",v:"low"},
        {l:"20€ — 40€",s:"&#9672;",v:"mid"},
        {l:"Plus de 40€",s:"&#9679;",v:"high"},
        {l:"Surprends-moi",s:"&#10024;",v:"any"}]},
      {q:"Quel type de cadeau ?",opts:[
        {l:"Un bijou à porter",s:"&#9830;",v:"jewel"},
        {l:"Une statue / déco",s:"&#9770;",v:"deco"},
        {l:"Pour méditer",s:"&#9790;",v:"medi"},
        {l:"Une pierre naturelle",s:"&#11042;",v:"stone"}]}
    ],
    res:function(a){
      if(a[1]==="low")return{t:"Cadeaux à moins de 10€",d:"Des petits trésors bouddhistes qui font toujours plaisir : bracelets, pierres et accessoires à moins de 10€.",tag:"Budget malin",url:"/collections/idees-cadeaux-bouddhistes-a-moins-de-10",btn:"Voir les cadeaux -10€"};
      if(a[2]==="jewel"&&a[0]==="m")return{t:"Bracelets Tibétains",d:"Des bracelets authentiques aux symboles forts, importés directement d’Asie. Idéal pour les hommes qui apprécient les objets chargés de sens.",tag:"Best-seller",url:"/collections/bracelet-tibetain",btn:"Voir les bracelets"};
      if(a[2]==="jewel")return{t:"Bijoux Bouddhistes",d:"Bracelets, malas et pendentifs minutieusement sélectionnés pour leur symbolique et leur qualité artisanale. Plus de 500 modèles.",tag:"+500 modèles",url:"/collections/bijoux-bouddhiste",btn:"Voir les bijoux"};
      if(a[2]==="deco")return{t:"Décoration Bouddha",d:"Statues, lanternes et objets zen pour créer un espace de sérénité à la maison. Artisanat authentique sélectionné à la source.",tag:"Artisanat authentique",url:"/collections/deco-bouddha",btn:"Voir la déco"};
      if(a[2]==="medi")return{t:"Accessoires Méditation",d:"Malas tibétains, coussins zafu, bols chantants — tout pour accompagner une pratique épanouie et régulière.",tag:"Idéal méditants",url:"/collections/accessoire-meditation",btn:"Voir les accessoires"};
      if(a[2]==="stone")return{t:"Lithothérapie",d:"Pierres naturelles aux vertus énergétiques expliquées. Chaque pierre est unique et porteuse d’une intention particulière.",tag:"Vertus expliquées",url:"/collections/lithotherapie",btn:"Voir les pierres"};
      return{t:"Meilleures Ventes",d:"Les produits préférés de notre communauté de 50 000 clients.",tag:"Coup de coeur",url:"/collections/meilleures-ventes",btn:"Voir les best-sellers"};
    }
  },
  {id:1,name:"Quelle pierre naturelle ?",sub:"Trouvez votre pierre de coeur",
    steps:[
      {q:"Comment vous sentez-vous en ce moment ?",opts:[
        {l:"Stressé(e) / anxieux",s:"&#10240;",v:"stress"},
        {l:"Manque d’énergie",s:"&#9889;",v:"energy"},
        {l:"Besoin de protection",s:"&#9651;",v:"protect"},
        {l:"Cœur fermé / seul(e)",s:"&#9825;",v:"love"}]},
      {q:"Votre intention principale ?",opts:[
        {l:"Apaiser mon mental",s:"&#9758;",v:"calm"},
        {l:"Attirer la chance",s:"&#9733;",v:"luck"},
        {l:"Me protéger",s:"&#9651;",v:"guard"},
        {l:"Ouvrir mon cœur",s:"&#10084;",v:"open"}]},
      {q:"Quelle couleur vous attire ?",opts:[
        {l:"Violet / Indigo",sub:"Améthyste",c:"#9B8FC7",v:"violet"},
        {l:"Rose / Blanc laiteux",sub:"Quartz Rose",c:"#E8A4B8",v:"rose"},
        {l:"Noir / Fumé",sub:"Obsidienne",c:"#3A3A3A",v:"noir"},
        {l:"Doré / Miel",sub:"Citrine",c:"#D4A843",v:"gold"}]}
    ],
    res:function(a){
      var M={
        violet:{t:"Améthyste",d:"Pierre de sérénité et de clarté mentale. L’améthyste calme le mental agité, favorise un sommeil réparateur et dissout les tensions accumulées.",tag:"Pierre apaisante",url:"/collections/bijoux-intention-anti-stress",btn:"Voir les bijoux améthyste"},
        rose:{t:"Quartz Rose",d:"Pierre de l’amour inconditionnel. Le quartz rose ouvre le chakra du cœur et invite à la douceur, la tendresse et l’auto-compassion.",tag:"Pierre du cœur",url:"/collections/bijoux-intention-amour",btn:"Voir les bijoux quartz rose"},
        noir:{t:"Obsidienne Noire",d:"Bouclier énergétique puissant. L’obsidienne absorbe les énergies négatives et protège profondément. Pierre d’ancrage et de force intérieure.",tag:"Protection totale",url:"/collections/obsidienne",btn:"Voir les bijoux obsidienne"},
        gold:{t:"Citrine",d:"Pierre du soleil et de l’abondance. La citrine stimule la motivation, attire la prospérité et recharge les batteries avec sa vibration lumineuse.",tag:"Pierre du soleil",url:"/collections/bijoux-intention-abondance",btn:"Voir les bijoux citrine"}
      };
      return M[a[2]]||M.violet;
    }
  },
  {id:2,name:"Quel Bouddha pour vous ?",sub:"Votre Bouddha idéal",
    steps:[
      {q:"Quelle énergie souhaitez-vous inviter ?",opts:[
        {l:"Joie & abondance",s:"&#9728;",v:"joy"},
        {l:"Sérénité & paix",s:"&#9670;",v:"peace"},
        {l:"Protection & force",s:"&#9651;",v:"protect"},
        {l:"Sagesse & clarté",s:"&#9788;",v:"wisdom"}]},
      {q:"Où vivra votre Bouddha ?",opts:[
        {l:"Salon / séjour",s:"&#9744;",v:"living"},
        {l:"Chambre / bureau",s:"&#9790;",v:"room"},
        {l:"Entrée de la maison",s:"&#9698;",v:"entry"},
        {l:"Jardin / terrasse",s:"&#9752;",v:"garden"}]},
      {q:"Quel style vous ressemble ?",opts:[
        {l:"Doré & lumineux",s:"&#10022;",v:"gold"},
        {l:"Naturel & sobre",s:"&#9673;",v:"natural"},
        {l:"Traditionnel & coloré",s:"&#9753;",v:"trad"},
        {l:"Epuré & moderne",s:"&#9633;",v:"modern"}]}
    ],
    res:function(a){
      if(a[0]==="joy"||(a[2]==="gold"&&a[0]!=="protect"))return{t:"Bouddha Rieur",d:"Le Bouddha Rieur (Budai) symbolise la joie, la chance et l’abondance. Son grand sourire apporte une énergie positive immédiate à votre espace.",tag:"Porte-bonheur",url:"/collections/statue-bouddha-rieur",btn:"Voir les Bouddha Rieur"};
      if(a[0]==="protect"||a[1]==="entry")return{t:"Tête de Bouddha",d:"Posée à l’entrée, la tête de Bouddha accueille et protège votre espace. Un symbole de sagesse et de sérénité intemporel.",tag:"Protection & Sérénité",url:"/collections/tete-de-bouddha",btn:"Voir les têtes de Bouddha"};
      if(a[0]==="wisdom"||a[2]==="trad")return{t:"Statues Bouddhistes",d:"Une collection de statues authentiques : Bouddha, Kwan Yin et divinités bouddhistes dans une esthétique traditionnelle soignée.",tag:"Artisanat traditionnel",url:"/collections/statue-bouddhiste",btn:"Voir les statues"};
      return{t:"Bouddha Méditation",d:"La posture de méditation apporte une énergie de paix profonde. Idéale dans un espace de méditation, une chambre ou un bureau.",tag:"Sérénité",url:"/collections/statue-bouddha",btn:"Voir les statues méditation"};
    }
  }
];

var AQ=0,STEP=0,ANS=[];
var FF="'Fraunces',Georgia,serif";
var FB="'DM Sans','Helvetica Neue',Arial,sans-serif";
var C_ORANGE='#c8692a',C_CREAM='#f5f0e8',C_GREEN='#173627',C_GOLD='#e7a400',C_TEXT='#1a1a1a',C_MUTED='#777';

function renderTabs(){
  var tb=document.getElementById('bb-tabs');
  if(!tb)return;
  tb.innerHTML=Q.map(function(q,i){
    var act=i===AQ;
    return '<button data-bb-tab="'+i+'" style="'+
      'padding:10px 20px;border-radius:100px;cursor:pointer;font-family:'+FB+';font-size:13px;letter-spacing:.02em;transition:all .2s;'+
      'border:1.5px solid '+(act?C_GREEN:'#d8d0c8')+';'+
      'background:'+(act?C_GREEN:'transparent')+';'+
      'color:'+(act?'#fff':C_MUTED)+';'+
      'font-weight:'+(act?'500':'400')+';'+
    '">'+q.name+'</button>';
  }).join('');
}

function dots(tot){
  var s='<div style="display:flex;gap:5px;align-items:center;">';
  for(var i=0;i<tot;i++){
    var done=i<STEP,cur=i===STEP;
    var w=cur?'20px':'8px',bg=done||cur?C_ORANGE:'#e0d8d0';
    s+='<div style="width:'+w+';height:8px;border-radius:100px;background:'+bg+';transition:all .3s ease;"></div>';
  }
  return s+'</div>';
}

function renderStep(){
  var quiz=Q[AQ];
  var tot=quiz.steps.length;
  var pct=STEP>=tot?100:Math.round((STEP/tot)*100);
  var pb=document.getElementById('bb-pb');
  if(pb)pb.style.width=pct+'%';
  var da=document.getElementById('bb-dots');
  if(da)da.innerHTML=dots(tot);
  var sl=document.getElementById('bb-slabel');
  if(sl)sl.textContent=STEP<tot?'Question '+(STEP+1)+' sur '+tot:'Votre résultat';
  var nb=document.getElementById('bb-next');if(nb)nb.style.display='none';
  var rc=document.getElementById('bb-result');if(rc)rc.style.display='none';
  var ag=document.getElementById('bb-answers');if(ag)ag.style.display='grid';
  var qt=document.getElementById('bb-qtxt');if(qt)qt.style.display='block';

  if(STEP<tot){
    var qo=quiz.steps[STEP];
    if(qt)qt.textContent=qo.q;
    if(ag){
      ag.innerHTML=qo.opts.map(function(o,i){
        var iconInner=o.c
          ?'<div style="width:100%;aspect-ratio:1;border-radius:50%;background:'+o.c+';box-shadow:0 2px 12px '+o.c+'55;"></div>'
            +(o.sub?'<span style="font-size:10px;color:'+C_MUTED+';font-family:'+FB+';letter-spacing:.03em;">'+o.sub+'</span>':'')
          :'<div style="width:44px;height:44px;border-radius:10px;background:'+C_CREAM+';display:flex;align-items:center;justify-content:center;font-size:20px;color:'+C_ORANGE+';">'+o.s+'</div>';
        return '<button data-bb-ans="'+i+'" data-bb-val="'+o.v+'" style="'+
          'display:flex;flex-direction:column;align-items:center;justify-content:center;gap:10px;'+
          'padding:18px 12px;min-height:110px;width:100%;'+
          'border:1.5px solid #e8e0d8;border-radius:14px;'+
          'background:#fff;cursor:pointer;text-align:center;'+
          'font-family:'+FB+';transition:border-color .15s,background .15s;'+
        '">'+
          iconInner+
          '<span style="font-size:13px;color:'+C_TEXT+';line-height:1.35;font-weight:400;">'+o.l+'</span>'+
        '</button>';
      }).join('');
    }
  } else {
    var r=quiz.res(ANS);
    if(qt)qt.style.display='none';
    if(ag)ag.style.display='none';
    if(pb)pb.style.width='100%';
    if(rc){
      rc.style.display='block';
      rc.innerHTML=
        '<div style="text-align:center;padding:1rem 0 0.5rem;">'+
          '<div style="display:inline-block;background:'+C_CREAM+';color:'+C_ORANGE+';'+
            'font-size:10px;font-weight:600;padding:5px 16px;border-radius:100px;'+
            'margin-bottom:1.25rem;letter-spacing:.12em;text-transform:uppercase;font-family:'+FB+';">'+r.tag+'</div>'+
          '<h3 style="font-family:'+FF+';font-size:28px;font-weight:600;color:'+C_TEXT+';margin:0 0 0.5rem;line-height:1.2;">'+r.t+'</h3>'+
          '<div style="display:flex;align-items:center;gap:8px;justify-content:center;margin:0.6rem 0 1.1rem;">'+
            '<div style="flex:1;max-width:60px;height:1px;background:#e8e0d8;"></div>'+
            '<span style="color:'+C_GOLD+';font-size:14px;letter-spacing:8px;">&#10022;</span>'+
            '<div style="flex:1;max-width:60px;height:1px;background:#e8e0d8;"></div>'+
          '</div>'+
          '<p style="font-size:14px;color:#555;line-height:1.8;margin:0 0 1.6rem;'+
            'max-width:360px;margin-left:auto;margin-right:auto;font-family:'+FB+';">'+r.d+'</p>'+
          '<a href="'+r.url+'" style="'+
            'display:inline-block;padding:14px 36px;'+
            'background:'+C_ORANGE+';color:#fff;'+
            'border-radius:100px;font-size:15px;font-weight:500;'+
            'text-decoration:none;letter-spacing:.03em;font-family:'+FB+';'+
          '">'+r.btn+' →</a>'+
          '<br><button data-bb-restart style="'+
            'margin-top:1rem;background:none;border:none;'+
            'color:#aaa;font-size:12px;cursor:pointer;'+
            'text-decoration:underline;font-family:'+FB+';letter-spacing:.02em;'+
          '">↵ Recommencer le quiz</button>'+
        '</div>';
    }
  }
}

document.addEventListener('click',function(e){
  var t=e.target.closest('[data-bb-tab]');
  if(t){AQ=parseInt(t.getAttribute('data-bb-tab'));STEP=0;ANS=[];renderTabs();renderStep();return;}
  var a=e.target.closest('[data-bb-ans]');
  if(a){
    ANS[STEP]=a.getAttribute('data-bb-val');
    var btns=document.querySelectorAll('[data-bb-ans]');
    btns.forEach(function(b){
      var sel=b===a||b.contains(a)||a.contains(b);
      b.style.borderColor=sel?C_ORANGE:'#e8e0d8';
      b.style.background=sel?'#fdf5ef':'#fff';
      if(sel)b.style.borderWidth='2px';
      else b.style.borderWidth='1.5px';
    });
    var nb=document.getElementById('bb-next');if(nb)nb.style.display='block';
    return;
  }
  if(e.target.closest('#bb-next')){STEP++;renderStep();return;}
  if(e.target.closest('[data-bb-restart]')){STEP=0;ANS=[];renderStep();return;}
});

function bbInit(){
  var root=document.getElementById('bb-quiz-root');
  if(!root)return;
  var qid=root.getAttribute('data-quiz-id');
  if(qid!==null&&qid!==''){
    AQ=parseInt(qid)||0;
    var tb=document.getElementById('bb-tabs');
    if(tb)tb.style.display='none';
  }
  renderTabs();
  renderStep();
}

if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',bbInit);}
else{bbInit();}
})();
